import { useFormikContext } from "formik";
import { useFormData } from "../../../contexts/FormData";

import { capitalize } from "lodash";

import { useQuery } from "@tanstack/react-query";

import { getInventoryAttributes } from "../apiService";

import Field from "../../../utils/FormikFields/Field";

const SelectCategory = () => {
  const { values, setFieldValue } = useFormikContext();
  const { formData } = useFormData();

  const { data: categories } = useQuery({
    queryKey: ['attributes'],
    queryFn: () => getInventoryAttributes(),
    staleTime: Infinity
  });

  return (
    <Field
      name="attribute"
      label="Category"
      formFieldType="select"
      options={categories?.map(el => ({ value: el.name, label: capitalize(el.name) }))}
    />
  )
};

export default SelectCategory;